module.exports = {"451203100":"庆远镇","451203101":"三岔镇","451203102":"洛西镇","451203103":"怀远镇","451203104":"德胜镇","451203105":"石别镇","451203106":"北山镇","451203107":"刘三姐镇","451203108":"洛东镇","451203200":"祥贝乡","451203203":"屏南乡","451203207":"福龙瑶族乡","451203208":"北牙瑶族乡","451203210":"同德乡","451203211":"安马乡","451203213":"龙头乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/451203.json
// module id = 2159
// module chunks = 0